import { z } from "zod";
import { IdPrefix, generateId } from "../utils";
import type { CompartmentType } from "./Compartment";

const BACKGROUND_MAX = 1180;
export const BACKGROUND_THICKNESS = 18;

export const BackgroundSchema = z.object({
	id: z.string(),
	x: z.number(),
	y: z.number(),
	z: z.number(),
	width: z.number().max(BACKGROUND_MAX).min(150),
	height: z.number(),
	depth: z.number().max(780).min(150),
});

export type Background = z.infer<typeof BackgroundSchema>;

export function createBackground(compartment: CompartmentType): Background {
	return {
		id: generateId(IdPrefix.Background),
		x: compartment.x,
		y: compartment.y,
		z: compartment.background?.z ?? 0,
		width: compartment.height,
		height: BACKGROUND_THICKNESS,
		depth: compartment.width,
	};
}
